import { z } from "zod";

export const embedCheckQuerySchema = z.object({
    url: z
        .string()
        .max(2048)
        .url()
        .refine((value) => /^https?:\/\//i.test(value)),
});

export type EmbedFraming = "allowed" | "blocked" | "unknown";
